document.addEventListener('DOMContentLoaded', function () {
  // ---------------------------------------------------
  // Password modal logic
  // ---------------------------------------------------
  document.querySelectorAll('.promo-password-modal').forEach(function (modal) {
    var openBtn = document.querySelector('.promo-password-button');
    // If you ever have multiple modals/buttons, you can refine this
    // to find the closest matching button instead.

    if (!openBtn || !modal) return;

    var closeBtn = modal.querySelector('.promo-password-close');
    var backdrop = modal.querySelector('.promo-password-backdrop');

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }

    openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  });

  // ---------------------------------------------------
  // Accordion logic
  // ---------------------------------------------------
  document.querySelectorAll('.promo-accordion').forEach(function (accordion) {
    var items = accordion.querySelectorAll('.promo-accordion-item');

    items.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      var panel = item.querySelector('.accordion-panel');

      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all items within this accordion
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var p = other.querySelector('.accordion-panel');
          if (p) p.style.maxHeight = null;
        });

        // Open clicked one if it was closed
        if (!isOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });
});
